export const smsCodeCookie = 'smsnotification';
export const smsServicePhoneNumber = 'smsphonenumber';
export const smsServiceMode = 'smsmode';

export const emailCodeCookie = 'emailnotification';
export const emailServiceAddress = 'emailAddress';
export const emailServiceMode = 'emailmode';

/**
 * The property a verification was made for.
 *
 * The cookies above are scoped to the whole portal domain, so without this a
 * session established for one address silently applied to the next one chosen
 * — the screen greeted you as "already verified as +45 …" for an address that
 * contact had nothing to do with, and on a shared device that is one citizen's
 * phone number shown to another. Verification proves you own a phone; it does
 * not say anything about which address you are managing.
 */
export const smsNotificationProperty = 'smsnotificationproperty';
export const emailNotificationProperty = 'emailnotificationproperty';

/** Every cookie the notification session is made of. */
export const notificationSessionCookies = [
  smsCodeCookie,
  smsServicePhoneNumber,
  smsServiceMode,
  smsNotificationProperty,
  emailCodeCookie,
  emailServiceAddress,
  emailServiceMode,
  emailNotificationProperty,
];
